import React from 'react';
import { IconButton } from '@cjdev-internal/visual-stack-x/components/Button';

export default ({ direction, onClick, disabled }) => (
  <IconButton data-testid={`chevron-${direction}`} icon={`chevron-${direction}`} round outline onClick={onClick} disabled={disabled} />
);
